import React from 'react';
import { Route, Redirect } from "react-router-dom";
import auth from "../utils/auth";
import Landing from '../pages/Landing';
import About from '../pages/About';
import StudentRegistrationForm from '../pages/StudentRegistrationForm';
import StudentPaymentForm from '../pages/StudentPaymentForm';
import StudentReceipt from '../pages/StudentReceipt';
import MiscStudentPaymentForm from '../pages/MiscStudentPaymentForm';
import StudentManagementList from '../pages/StudentManagementList';
import TeacherManagementList from '../pages/TeacherManagementList';
import StudentManagementForm from '../pages/StudentManagementForm';
import Hook from '../pages/Hook';
import GlobalState from '../pages/GlobalState';
import NewCourseForm from "../pages/NewCourseForm";
import TeacherRegistrationForm from "../pages/TeacherRegistrationForm";
import TeacherManagementForm from "../pages/TeacherManagementForm";
import TeacherSalaryList from "../pages/TeacherSalaryList";
import HistoryPaymentForm from "../pages/HistoryPaymentForm";
import ClassroomManagementForm from "../pages/ClassroomManagement";
import StudentFinanceReport from "../pages/StudentFinanceReport";
import MonthlyFinanceReport from "../pages/MonthlyFinanceReport";
import AnnouncementManagement from "../pages/AnnouncementManagement";
import {ROLE_ADMIN, ROLE_EMPLOYEE} from "../utils/constants"
import QuizManagement from "../pages/QuizManagement";
import NoteManagement from "../pages/NoteManagement";
import TimetableManagement from "../pages/TimetableManagement";
import NewEnrolmentList from "../pages/NewEnrolmentList";
const routes = [
  {
    path: "/",
    exact: true,
    component: Landing
  },
  {
    path: "/student/register",
    exact: true,
    component: StudentRegistrationForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/tuition/payment",
    exact: true,
    component: StudentPaymentForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/tuition/receipt",
    exact: true,
    component: StudentReceipt,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/management",
    exact: true,
    component: StudentManagementList,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/enrolment/management",
    exact: true,
    component: NewEnrolmentList,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/management/form",
    exact: true,
    component: StudentManagementForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/teacher/management",
    exact: true,
    component: TeacherManagementList,
    role: [ROLE_ADMIN],
    isProtected: true
  },
  {
    path: "/teacher/management/form",
    exact: true,
    component: TeacherManagementForm,
    role: [ROLE_ADMIN],
    isProtected: true
  },
  {
    path: "/teachers/salary",
    exact: true,
    component: TeacherSalaryList,
    role: [ROLE_ADMIN],
    isProtected: true
  },
  {
    path: "/student/misc/payment",
    exact: true,
    component: MiscStudentPaymentForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/course/register",
    exact: true,
    component: NewCourseForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/teacher/register",
    exact: true,
    component: TeacherRegistrationForm,
    role: [ROLE_ADMIN],
    isProtected: true
  },
  {
    path: "/payment/history",
    exact: true,
    component: HistoryPaymentForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/classroom",
    exact: true,
    component: ClassroomManagementForm,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/finance/report/student",
    exact: true,
    component: StudentFinanceReport,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/finance/report/month",
    exact: true,
    component: MonthlyFinanceReport,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/announcements",
    exact: true,
    component: AnnouncementManagement,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/quiz",
    exact: true,
    component: QuizManagement,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/notes",
    exact: true,
    component: NoteManagement,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "/student/timetable",
    exact: true,
    component: TimetableManagement,
    role: [ROLE_ADMIN, ROLE_EMPLOYEE],
    isProtected: true
  },
  {
    path: "*",
    component: Landing,
  },
];


const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props =>
      auth.authenticate()
        ? (<Component {...props} />)
        : (<Redirect to={{ pathname: '/', state: { from: props.location } }} />)
    }
    />
  );
}

export {
  routes as default,
  ProtectedRoute
}
